import React from "react";

export const BlockClientContext = React.createContext({
    doSearch: null,
    parent: null,
});